import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "card bg-light" }
const _hoisted_4 = { class: "card-body py-4" }
const _hoisted_5 = { class: "fs-6" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = { class: "text-muted fs-7 ms-2" }
const _hoisted_8 = {
  key: 0,
  class: "fs-7 mt-1"
}
const _hoisted_9 = { class: "fw-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.baseUnit)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('message.BASE_UNIT')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.baseUnit.name) + " (" + _toDisplayString(_ctx.baseUnit.measurement) + ") ", 1),
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('message.MANAGED_IN_SMART')), 1)
              ]),
              (_ctx.sellingUnits.length > 1)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('message.SELLING_UNITS')) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.sellingUnits.join(', ')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}